<template>
  <div>
    <!-- 入口挂件 -->
    <entrance
      v-if="entranceVisible"
      :entrance-img="entranceImg"
      @click="clickEntrance"
    />
    <modal v-if="visible" append-to-body height="auto">
      <div class="plv-iar-topic"  v-click-out-side="closeModal">
        <div class="plv-iar-topic-header">
          <div class="plv-iar-topic-header__close">
            <img src="./imgs/icon-close.png" @click="closeModal"/>
          </div>
        </div>
        <topic-content :topic-data="topicData" @choose-answer="chooseAnswer"/>
      </div>
    </modal>
  </div>
</template>

<script>
import Entrance from '@/components/topic/entrance';
import TopicContent from '@/components/topic/TopicContent';
import modal from '@/components/common/modal/PcModal';
import ClickOutSide from '@/assets/utils/click-out-side';
import mixin from './mixin';

export default {
  name: 'PcTopic',
  mixins: [mixin],
  components: { TopicContent, modal, Entrance },
  directives: { ClickOutSide },
};
</script>

<style lang="scss">
.plv-iar-modal--topic {
  z-index: 20;
}
.plv-iar-topic-header {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 30px;
}
.plv-iar-topic-header__close {
  position: absolute;
  right: 0;
  cursor: pointer;
  img {
    width: 36px;
    height: 36px;
  }
}
.plv-iar-topic {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 20;
  background: url(./imgs/bg.png) 100% 100%;
  background-size: 100% 100%;
  padding: 28px 24px;
  border-radius: 8px;
}

</style>
